import {usePermitTypesWithColors} from "permit/hooks";
import {DateUtil} from "base/format/utilities";
import {Tag} from "base/shared/components";
import {SimpleTable} from "base/table/components";
import Typography from "@mui/material/Typography";

const PermitTypesAndDatesTable = ({permit}) => {
    const types = permit?.types;
    const extensions = permit?.extension_set;

    const {filteredTypesWithColors} = usePermitTypesWithColors(types);

    const getGuidesTableData = () => {
        const hasExtensions = extensions && extensions.length > 0;

        const dataRows =
            filteredTypesWithColors?.map(type => {
                const startField = `${type.value}_start_date`;
                const endField = `${type.value}_end_date`;

                const originalStart = permit[startField];
                const originalEnd = permit[endField];
                const originalDates =
                    originalStart && originalEnd
                        ? `${DateUtil.formatDateShort(
                              originalStart
                          )} – ${DateUtil.formatDateShort(originalEnd)}`
                        : "-";

                let extensionDates = "-";
                if (hasExtensions && extensions[0]) {
                    const extStart = extensions[0][startField];
                    const extEnd = extensions[0][endField];
                    if (extStart && extEnd) {
                        extensionDates = `${DateUtil.formatDateShort(
                            extStart
                        )} – ${DateUtil.formatDateShort(extEnd)}`;
                    }
                }

                return {
                    type,
                    originalDates,
                    extensionDates,
                };
            }) || [];

        const baseColumns = [
            {
                id: "type",
                label: "Guia",
                width: 60,
                formatFunction: row => (
                    <Tag color={row.type.color} textColor={row.type.contrastTextColor}>
                        {row.type.label}
                    </Tag>
                ),
            },
            {
                id: "originalDates",
                label: "Datas da autorização",
                width: hasExtensions ? 20 : 40,
            },
        ];

        const columns = hasExtensions
            ? [
                  ...baseColumns,
                  {
                      id: "extensionDates",
                      label: "Datas da prorrogação",
                      width: 20,
                  },
              ]
            : baseColumns;

        return {dataRows, columns};
    };

    const {dataRows, columns} = getGuidesTableData();

    return <SimpleTable dataRows={dataRows} tableColumns={columns} />;
};

export default PermitTypesAndDatesTable;
